import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChildFriendlyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"child_friendly"}/>
}
